import { EVALUATION_TYPES } from "../../../constants/storageConstants";
import { getEvaluationType } from "../../../util/dataSelectors";
import DemandProfiles from "./DemandProfiles";
import VolumeAdjustmentFactors from "./VolumeAdjustmentFactors";

export default function TrafficVolumesDefaults(props) {
  const isCapXFlow =
    getEvaluationType(props.projectData) === EVALUATION_TYPES.CAP_X;
  return isCapXFlow ? (
    <VolumeAdjustmentFactors {...props} />
  ) : (
    <DemandProfiles {...props} />
  );
}
